import { IconTitle2 } from '@xing-com/icons';

import * as Styled from '../styles';
import { type ToolProps } from '../types';

export const HeadingH2Tool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
      disabled={
        disabled ||
        !editor.can().chain().focus().toggleHeading({ level: 2 }).run()
      }
      className={editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}
    >
      <IconTitle2 width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
